export default "__VITE_ASSET__TFkOZoss__"